import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './boarding-certificate-common.actions';
import { BoardingCertificateCommonState } from './boarding-certificate-common.state';

/**
 * boardingCertificateCommon initial state
 */
export const boardingCertificateCommonInitialState: BoardingCertificateCommonState = {
  model: null,
};

/**
 * List of basic actions for BoardingCertificateCommon Store
 */
export const boardingCertificateCommonReducerFeatures: ReducerTypes<BoardingCertificateCommonState, ActionCreator[]>[] =
  [
    on(actions.setBoardingCertificateCommon, (_state, payload) => ({ ...payload })),

    on(actions.updateBoardingCertificateCommon, (state, payload) => ({ ...state, ...payload })),

    on(actions.resetBoardingCertificateCommon, () => boardingCertificateCommonInitialState),
  ];

/**
 * BoardingCertificateCommon Store reducer
 */
export const boardingCertificateCommonReducer = createReducer(
  boardingCertificateCommonInitialState,
  ...boardingCertificateCommonReducerFeatures
);
